/* eslint-disable no-restricted-globals */
/* eslint-disable unicorn/no-useless-undefined */
/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable unicorn/prefer-query-selector */
/* eslint-disable unicorn/better-regex */
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Clear, FileUpload, OpenInNew, Visibility } from "@mui/icons-material";
import { FormEntity } from "../../../../api/Forms/Entity/FormEntity";
import useViewModel from "./ViewModel";
import { convertToBase64 } from "../../../../utils";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectProfile } from "../../../../store/profile/selector";
import { UserInterfaceState } from "../../../../shared/Enum";
import { UpdateFormDto } from "../../../../api/Forms/Entity/UpdateFormDto";
import ConfirmationDialog from "../../../../shared/Components/ConfirmationDialog";
import PreviewDialog from "../../../../shared/Components/PreviewDialog";
import LoadingBackdrop from "../../../../shared/Components/LoadingBackdrop";
import { enqueueSnackbar, useSnackbar } from "notistack";

interface Prop {
  defaultValue?: FormEntity;
  onSubmit(payload: any): void;
}

export function ServiceForm({ defaultValue, onSubmit }: Prop) {
  const urlPattern =
    /^(https?:\/\/)?((([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})|(([0-9]{1,3}\.){3}[0-9]{1,3}))(:[0-9]{1,5})?(\/[-a-zA-Z0-9()@:%_+.~#?&/=]*)?(\?[;&a-zA-Z0-9%_+.~#?&/=]*)?(\#[-a-zA-Z0-9()@:%_+.~#?&/=]*)?$/i;
  const handleFormData = (name: string, value: any) => {
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const profile = useSelector(selectProfile);
  const snackbar = useSnackbar();

  const [formData, setFormData] = useState<UpdateFormDto>({
    formId: "",
    binusianId: profile.binusianId,
    imageName: "",
    imageBase64: "",
    isPublic: false,
    link: "",
    locationId: "",
    name: "",
    description: "",
  });
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [previewDialog, setPreviewDialog] = useState(false);
  const [validation, setValidation] = useState(false);
  const { data, method } = useViewModel();
  const navigate = useNavigate();

  useEffect(() => {
    method.onGetLocationList();
    if (defaultValue) {
      setFormData({
        formId: defaultValue?.id,
        binusianId: profile.binusianId,
        imageName: defaultValue.imageName,
        isPublic: defaultValue.isPublic,
        link: defaultValue.link,
        locationId: defaultValue.locationId,
        name: defaultValue.name,
        description: defaultValue.description,
      });
    }
  }, [defaultValue]);

  useEffect(() => {
    if (UserInterfaceState.isError(data.uiState)) {
      enqueueSnackbar({
        message:
          "Oops, something went wrong. Please try again later. If the issue persists, try refreshing the page or restarting the app.",
        variant: "error",
      });
    }
  }, [data.uiState]);

  useEffect(() => {
    if (data.locationList.length > 0 && !defaultValue) {
      handleFormData("locationId", data.locationList[0].locationId);
    }
  }, [data.locationList]);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      handleFormData("imageName", file.name);
      await convertToBase64(file).then((res) =>
        handleFormData("imageBase64", res)
      );
    }
  };

  const handleButtonClick = () => {
    const fileInput = document.getElementById("file-input") as HTMLInputElement;
    fileInput.value = "";
    fileInput.click();
  };

  return (
    <Box className="flex flex-col w-full md:p-8 gap-10">
      <ConfirmationDialog
        description={`Are you sure you want to ${
          defaultValue ? "update" : "create"
        } this
            location?`}
        onCancel={() => setConfirmationDialog(false)}
        onClose={() => setConfirmationDialog(false)}
        onSubmit={() => {
          setConfirmationDialog(false);
          onSubmit(formData);
        }}
        open={confirmationDialog}
      />
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">Location Name</Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <Select
              value={formData.locationId}
              onChange={(e) => handleFormData("locationId", e.target.value)}
              className="bg-white w-full md:w-1/6"
            >
              {data.locationList.map((e) => (
                <MenuItem key={e.locationId} value={e.locationId}>
                  {e.locationName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">Form Services Name</Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <TextField
              id="filled-basic"
              variant="outlined"
              value={formData.name}
              onChange={(e) => handleFormData("name", e.target.value)}
              error={validation && formData.name == ""}
              helperText={
                validation && formData.name == "" && "Form Name is required!"
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">
                Form Services Description
              </Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <TextField
              id="filled-basic"
              variant="outlined"
              value={formData.description}
              onChange={(e) => handleFormData("description", e.target.value)}
              error={validation && formData.description == ""}
              helperText={
                validation &&
                formData.description == "" &&
                "Form Description is required!"
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">
                File Upload Image Service BM
              </Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <input
              id="file-input"
              type="file"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            <TextField
              value={formData.imageName}
              variant="outlined"
              disabled
              error={validation && formData.imageName == ""}
              helperText={
                validation && formData.imageName == "" && "Image is required!"
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Box className="flex">
                      <Button
                        className="p-1 min-w-min"
                        onClick={handleButtonClick}
                      >
                        <FileUpload />
                      </Button>
                      <Button
                        className="p-1 min-w-min"
                        onClick={() => {
                          setPreviewDialog(true);
                        }}
                        disabled={formData.imageName == ""}
                      >
                        <Visibility />
                      </Button>
                      <Button
                        className="p-1 min-w-min"
                        onClick={() => {
                          handleFormData("name", "");
                          handleFormData("imageBase64", "");
                          const fileInput = document.getElementById(
                            "file-input"
                          ) as HTMLInputElement;
                          fileInput.value = "";
                        }}
                      >
                        <Clear />
                      </Button>
                    </Box>
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">Form Service Link</Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <Box className="flex w-full">
              <TextField
                id="filled-basic"
                variant="outlined"
                className="w-full"
                InputProps={{
                  style: {
                    paddingRight: 0,
                  },
                  endAdornment: (
                    <Button
                      className="h-full ml-2"
                      variant="contained"
                      onClick={() => {
                        if (urlPattern.test(formData.link)) {
                          const toOpen = window.open(
                            formData.link,
                            "_blank",
                            "noopener,noreferrer"
                          );
                          if (toOpen) toOpen.opener = null;
                        } else {
                          snackbar.enqueueSnackbar("Please type a valid URL", {
                            variant: "error",
                          });
                        }
                      }}
                    >
                      <OpenInNew />
                    </Button>
                  ),
                }}
                value={formData.link}
                onChange={(e) => handleFormData("link", e.target.value)}
                error={
                  validation &&
                  (formData.link == "" || !urlPattern.test(formData.link))
                }
                helperText={
                  validation &&
                  (formData.link === "" || !urlPattern.test(formData.link)) &&
                  (formData.link === ""
                    ? "Form Service Link is required!"
                    : "Please enter a valid URL.")
                }
              />
            </Box>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} className="flex">
          <FormControl className="self-center flex gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">
                Form Services Accessible for Non-Binusian
              </Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={formData.isPublic ? "Yes" : "No"}
              onChange={(e) =>
                handleFormData("isPublic", e.target.value == "Yes")
              }
            >
              <Box className="flex">
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </Box>
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <Box className="flex justify-center gap-5 mt-10">
        <Button
          variant="contained"
          className="capitalize py-3 px-10 text-lg"
          size="large"
          onClick={() => navigate("/master-form")}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          className="capitalize py-3 px-10 text-lg"
          size="large"
          onClick={() => {
            if (
              formData.imageName == "" ||
              formData.link == "" ||
              formData.name == "" ||
              formData.description == "" ||
              !urlPattern.test(formData.link)
            ) {
              setValidation(true);
            } else {
              setConfirmationDialog(true);
            }
          }}
        >
          Save
        </Button>
      </Box>
      <LoadingBackdrop isOpen={UserInterfaceState.isLoading(data.uiState)} />
      <PreviewDialog
        open={previewDialog}
        onClose={() => setPreviewDialog(false)}
        imageBase64={formData.imageBase64}
        imageUrl={defaultValue?.imageUrl}
        title={formData.imageName}
      />
    </Box>
  );
}
